import { motion } from "framer-motion";

const PLANS = [
  { name: "Medico generalista", price: "129" },
  { name: "Pediatra", price: "159" },
  { name: "Geriatra e internista", price: "159" },
  { name: "Otorinolaringoiatra", price: "159" },
  { name: "Pneumologo", price: "159" },
  { name: "Dermatologo", price: "159" },
  { name: "Cardiologo con ECG", price: "199" },
];

export default function PricingSection() {
  return (
    <section id="prezzi" className="bg-[#F6F4FA] py-20 sm:py-28" data-testid="pricing-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-[#5B2C91]"
          >
            <span className="h-2 w-2 rounded-full bg-[#D4F84A]" />
            Prezzi
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 22 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="font-heading mt-5 text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#1F152E]"
            data-testid="pricing-title"
          >
            Un prezzo chiaro prima della conferma
          </motion.h2>
        </div>

        <div className="mt-12 flex flex-wrap justify-center gap-4">
          {PLANS.map((p, i) => (
            <motion.div
              key={p.name}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.06, ease: [0.16, 1, 0.3, 1] }}
              className="flex w-full flex-col rounded-3xl bg-white p-6 ring-1 ring-[#5B2C91]/8 shadow-[0_8px_30px_rgb(91,44,145,0.05)] transition-transform duration-300 hover:-translate-y-1.5 sm:w-[calc(50%-0.5rem)] lg:w-[calc(25%-0.75rem)]"
              data-testid="pricing-card"
            >
              <h3 className="font-heading text-base font-semibold leading-snug text-[#1F152E]">
                {p.name}
              </h3>
              <div className="mt-4">
                <span className="font-heading text-3xl font-bold text-[#5B2C91]">€{p.price}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
